export const CHANNEL_OPTIONS = [
  { label: 'email', value: 'email' },
  { label: 'text', value: 'text' },
  { label: 'telegram', value: 'telegram' },
  // { label: 'push', value: 'push' },
];

export const CHANNEL_DISPLAY = [
  { key: 'email', label: 'Email' },
  { key: 'text', label: 'Text' },
  // { key: 'push', label: 'Push' },
  { key: 'telegram', label: 'Telegram' },
];

export const CHANNEL_LABELS = Object.fromEntries(CHANNEL_DISPLAY.map((c) => [c.key, c.label]));
